import type { LanguageContext } from "../app/store";
import type { LanguagePack, Progress } from "../types";
import { resolveContentPart } from "./catalog";
import type { Selection } from "../types";

/** Completed lessons / listened programs / listened stories, shared by the catalog and Stats. */
export function trackCounts(ctx: LanguageContext) {
  const { progress: p, lessons, programs, stories } = ctx;
  const reviewed = new Set(p.tracks.study.reviewedWordIds);
  const done = (id: string) => p.tracks.audio.programs[id]?.completed || p.tracks.audio.programs[id]?.everCompleted;
  return {
    study: lessons.filter((l) => l.wordIds.every((id) => reviewed.has(id))).length,
    audio: programs.filter((x) => x.lessonId && done(x.id)).length,
    stories: stories.filter((s) => p.exposure.stories[s.id]?.plays > 0).length,
  };
}

/** Word exposure shared by Study, Audio and Stories, over the whole language or one content part. */
export function summarizeProgress(pack: LanguagePack, p: Progress, selection: Selection | null) {
  const part = selection?.partId ? resolveContentPart(pack, selection) : null;
  const words = part ? part.deck : pack.deck;
  const reviewed = new Set(p.tracks.study.reviewedWordIds);
  const totals = { words: 0, encountered: 0, reviewed: 0, audio: 0, reading: 0, reviews: 0, exposures: 0 };
  for (const w of words) {
    const r = p.exposure?.words?.[w.id] ?? {};
    const audio = (r.studyAudio || 0) + (r.storyAudio || 0);
    const reading = (r.studyReads || 0) + (r.storyReads || 0);
    totals.words++;
    if (audio + reading > 0) totals.encountered++;
    if (reviewed.has(w.id)) totals.reviewed++;
    totals.audio += audio; totals.reading += reading; totals.reviews += r.reviews || 0; totals.exposures += audio + reading;
  }
  return totals;
}
